import type { SortingState } from "@tanstack/react-table";

export interface ScopeKeyParams {
  scheduleId: number | null;
  nodeId: number | null;
  sorting: SortingState;
  search: string;
  excludeCompleted: boolean;
  criticalOnly: boolean;
}

/**
 * Identity of a server query scope. It changes only when the result set is
 * *replaced* — schedule, WBS section, sort, search, or a filter toggle — and
 * never when infinite-scroll appends another page (page size / row count are
 * deliberately not part of it).
 *
 * The virtualized table is keyed on this string so it remounts on a scope
 * change: scroll resets to the top and a fresh virtualizer is built, which is
 * what makes "scroll down, then pick a section" reliable. Were the offset kept,
 * a window computed past the end of a new, shorter list would render nothing.
 */
export function buildScopeKey(p: ScopeKeyParams): string {
  const sort = p.sorting[0];
  return [
    p.scheduleId ?? "",
    p.nodeId ?? "",
    sort ? `${sort.id}:${sort.desc ? "desc" : "asc"}` : "",
    p.search,
    p.excludeCompleted ? "1" : "0",
    p.criticalOnly ? "1" : "0",
  ].join("|");
}
